import React, { useEffect } from "react";
import { styled } from '@mui/material/styles';
// import DateFnsUtils from "@date-io/date-fns";
import Grid from "@mui/material/Grid";
// import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
// import { addDays } from 'date-fns';
import { FormControl, IconButton, Container, CircularProgress } from "@mui/material";
import { Typography } from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Button from "@mui/material/Button";
import Input from "@mui/material/Input";
import Slide from "@mui/material/Slide";
import { DeleteForever } from "@mui/icons-material";
import clsx from "clsx";
// import { locales } from "../../../helpers/format";
import { useTranslation } from "react-i18next";
import HelpIcon from '@mui/icons-material/Help';
import Tooltip from '@mui/material/Tooltip';

import { DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from "dayjs";
import i18next from "i18next";

const PREFIX = 'SCHEDULE_TYPE';

const classes = {
  zeForm: `${PREFIX}-zeForm`,
  actionBar: `${PREFIX}-actionBar`,
  delete: `${PREFIX}-delete`,
  confirmDelete: `${PREFIX}-confirmDelete`,
  flex02: `${PREFIX}-flex02`,
  flex1: `${PREFIX}-flex1`,
  fullHW: `${PREFIX}-fullHW`,
  noRadius: `${PREFIX}-noRadius`,
  buttonFile: `${PREFIX}-buttonFile`,
  minW75: `${PREFIX}-minW75`,
  buttonHttp: `${PREFIX}-buttonHttp`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.zeForm}`]: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      minHeight: '550px'
    },
    [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
      position: 'relative',
      minHeight: '455px'
    },
  },

  [`& .${classes.actionBar}`]: {
    [`${theme.breakpoints.up('xs')} and (orientation: portrait)`]: {
      position: "absolute",
      left: 0,
      bottom: 0,
      minHeight: '40px',
      display: 'flex',
      width: '100%',
    },
    [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
      minHeight: '40px',
      display: 'flex',
      width: 'calc(100% + 30px)',
      position: 'absolute',
      bottom: '0',
      left: '-30px',
    }
  },

  [`& .${classes.delete}`]: {
    flex: 0.2,
    textAlign: 'center',
    borderLeft: '1px solid #303030',
    backgroundColor: '#692222',
  },

  [`& .${classes.confirmDelete}`]: {
    position: "absolute",
    left: 0,
    bottom: 0,
    minHeight: '50px',
    display: 'flex',
    width: '100%',
    backgroundColor: '#692222',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '1rem',
    paddingRight: '1rem',
  },

  [`& .${classes.flex02}`]: {
    flex: '0.2',
  },

  [`& .${classes.flex1}`]: {
    flex: '1',
  },

  [`& .${classes.fullHW}`]: {
    width: '100%',
    height: '100%',
  },

  [`& .${classes.noRadius}`]: {
    borderRadius: 0,
  },

  [`& .${classes.buttonFile}`]: {
    textAlign: "center",
    marginTop: "1rem",
  },

  [`& .${classes.minW75}`]: {
    minWidth: '75px'
  },

  [`& .${classes.buttonHttp}`]: {
    textTransform: 'lowercase',
    minWidth: 0,
    padding: '0 3px 0 0',
  }
}));

export const SCHEDULE_TYPE = {
  URL: 'selectUrl',
  NEW_VIDEO: 'selectVideo',
  IMAGE: 'selectImage',
  CAMPAIGN: 'selectCampaign',
}

export const ALGORITHM_TYPE = {
  FIFO: 'FIFO',
  FILO: 'FILO',
  RANDOM: 'RANDOM',
  PLAYLIST: 'PLAYLIST',
}

export default function ScheduleForm(props) {
  const { t } = useTranslation();
  const [form, setForm] = React.useState({
    title: props.form ? props.form.title : "",
    description: props.form ? props.form.title : "",
    videoTitle: "",
    videoDescription: "",
    ...props.form,
    beginDate: props.form ? dayjs(props.form.beginDate).format("YYYY-MM-DDTHH:mm:ssZ") : dayjs().format("YYYY-MM-DDTHH:mm:ssZ"),
    // endDate: props.form ? new Date(props.form.endDate) : addDays(new Date(), 1),
    endDate: props.form ? dayjs(props.form.endDate).format("YYYY-MM-DDTHH:mm:ssZ") : dayjs().add(1, 'day').format("YYYY-MM-DDTHH:mm:ssZ"),
    type: props.form && props.form.campaignId ? SCHEDULE_TYPE.CAMPAIGN : SCHEDULE_TYPE.URL,
    http: props.form && !props.form.campaignId && props.form.targetUrl.indexOf("http://") >= 0 ? "http://" : "https://",
    file: null,
    targetUrl: props.form && !props.form.campaignId ? props.form.targetUrl.substring(props.form.targetUrl.indexOf('http://') >= 0 ? 7 : props.form.targetUrl.indexOf('https://') >= 0 ? 8 : 0) : "",
  });
  const [canSubmit, setCanSubmit] = React.useState(checkSubmit());
  const [selectedCampaign, setSelectedCampaign] = React.useState(null);
  const [confirmDelete, setConfirmDelete] = React.useState(false);

  useEffect(() => {
    if (props.form && props.form.campaignId) {
      const currentCampaign = props.campaigns.find(campaign => campaign.id === props.form.campaignId);
      setSelectedCampaign({
        campaign: currentCampaign,
        uniqueKey: currentCampaign.uniqueKey,
        campaignName: currentCampaign.name,
        campaignId: currentCampaign.id,
        type: props.form.campaign.type,
        availableTypes: currentCampaign.type.split('/'),
        algorithm: props.form.campaign.algorithm,
      })
    }
  }, [props.form])

  const handleDateChange = (key, date) => {
    setForm({
      ...form,
      [key]: dayjs(date).format("YYYY-MM-DDTHH:mm:ssZ"),
    });
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    activateSubmit();
  }, [form]);

  function cancel() {
    props.cancel();
  }

  function validate() {
    if (selectedCampaign && form.type === SCHEDULE_TYPE.CAMPAIGN) {
      let tmpform = {
        ...form,
        algorithm: selectedCampaign.algorithm,
        campaignId: selectedCampaign.campaignId,
        type: selectedCampaign.type,
        description: form.description,
        title: form.title,
      }
      props.validate(tmpform);
    } else {
      props.validate(form);
    }
  }

  function deletePlanification() {
    props.deleteSchedule(form.id);
  }

  function confirmDeletePlanification() {
    setConfirmDelete(true);
  }

  function handleHttp() {
    setForm((prev) => ({
      ...form,
      http: prev.http === 'http://' ? 'https://' : 'http://',
    }));
  }

  function isValidDate(d) {
    let zeDate = dayjs(d);
    if (zeDate && !(zeDate instanceof Date)) {
      zeDate = dayjs(d);
    }
    return zeDate && zeDate != null;
  }

  function activateSubmit() {
    const isFormOk = !checkSubmit();
    setCanSubmit(!isFormOk);
    if (props.saveForm && isFormOk) {
      props.saveForm(form);
    }
  }

  function checkSubmit() {
    return (form.type === SCHEDULE_TYPE.URL && (!form.targetUrl || form.targetUrl.length === 0)) || !isValidDate(form.beginDate) || !isValidDate(form.endDate)
      || !form.title || !form.description || (form.type !== SCHEDULE_TYPE.URL && form.type !== SCHEDULE_TYPE.CAMPAIGN && (!form.videoTitle || !form.videoDescription || !form.file));
  }

  function handleFileChange(e) {
    if (e.target.files && e.target.files.length > 0) {
      setForm({
        ...form,
        file: e.target.files[0],
      });
    }
  }

  useEffect(() => {
    if (form.type === SCHEDULE_TYPE.CAMPAIGN && !form.id) {
      if (props.campaigns.length > 0) {
        const lastCampaign = props.campaigns[props.campaigns.length - 1];
        let tmp = {
          campaign: lastCampaign,
          uniqueKey: lastCampaign.uniqueKey,
          campaignName: lastCampaign.name,
          campaignId: lastCampaign.id,
          type: lastCampaign.type.split('/')[0],
          availableTypes: lastCampaign.type.split('/'),
          algorithm: ALGORITHM_TYPE.PLAYLIST,
        }
        setSelectedCampaign(tmp)
      }
    }
  }, [form.type])

  function handleCampaignChange(uniqueKey) {
    const tmp = props.campaigns.find(item => item.uniqueKey === uniqueKey);
    setSelectedCampaign({
      campaign: tmp,
      campaignName: tmp.name,
      uniqueKey: tmp.uniqueKey,
      campaignId: tmp.id,
      type: tmp.type.split('/')[0],
      availableTypes: tmp.type.split('/'),
      algorithm: ALGORITHM_TYPE.PLAYLIST,
    })
  }

  function handleCampaignValueChange(value, key) {
    let tmp = { ...selectedCampaign };
    tmp[key] = value;
    setSelectedCampaign(tmp);
  }

  return (
    <Root>
      <div className={classes.zeForm} style={{ paddingBottom: !props.isMultiple ? 75 : 10 }}>
        <FormControl fullWidth sx={{marginTop: '1rem'}}>
          <InputLabel>{t('myDesign.zones.schedule.form.title')}</InputLabel>
          <Input
            type="text"
            id="title"
            label={t('myDesign.zones.schedule.form.titleLabel')}
            name="title"
            value={form.title}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl fullWidth sx={{ margin: '0.5rem 0 1rem 0' }}>
          <InputLabel>{t('myDesign.zones.schedule.form.description')}</InputLabel>
          <Input
            type="text"
            id="description"
            label={t('myDesign.zones.schedule.form.descriptionLabel')}
            name="description"
            value={form.description}
            onChange={handleChange}
          />
        </FormControl>
        {/* <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locales[i18n.languages[1]]}> */}
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18next.language.substring(0, 2)}>
          <Grid container justifyContent="space-around" spacing={2}>
            <Grid item xs={12}>
              {/* <KeyboardDateTimePicker
                margin="normal"
                id="from-date-picker-dialog"
                label={t('myDesign.zones.schedule.form.from')}
                format="Pp"
                value={form.beginDate}
                onChange={(e, value) => handleDateChange('beginDate', e)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                minDate={form.id ? form.beginDate : new Date()}
                // disabled={!isNaN(form.id)}
                className={classes.fullHW}
              /> */}
              <DateTimePicker
                margin="normal"
                id="from-date-picker-dialog"
                label={t('myDesign.zones.schedule.form.from')}
                value={dayjs(form.beginDate)}
                onChange={(e, value) => handleDateChange('beginDate', e)}
                minDate={form.id ? dayjs(form.beginDate) : dayjs()}
                className={classes.fullHW}
              />
            </Grid>
            <Grid item xs={12}>
              {/* <KeyboardDateTimePicker
                margin="normal"
                id="to-date-picker-dialog"
                label={t('myDesign.zones.schedule.form.to')}
                format="Pp"
                value={form.endDate}
                onChange={(e) => handleDateChange('endDate', e)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                minDate={form.beginDate}
                className={classes.fullHW}
              /> */}
              <DateTimePicker
                margin="normal"
                id="to-date-picker-dialog"
                label={t('myDesign.zones.schedule.form.to')}
                value={dayjs(form.endDate)}
                onChange={(e) => handleDateChange('endDate', e)}
                minDate={dayjs(form.beginDate)}
                className={classes.fullHW}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl className={classes.minW75} fullWidth>
                <InputLabel id="select-type-label">{t('myDesign.zones.schedule.form.type')}
                  {form.type === SCHEDULE_TYPE.URL &&
                    <Tooltip
                      title={t(`myDesign.zones.schedule.form.selectUrlTooltip`)}
                      aria-label={t(`myDesign.zones.schedule.form.selectUrlTooltip`)}
                      placement="right-start"
                    >
                      <HelpIcon style={{ marginLeft: '0.5rem' }} />
                    </Tooltip>
                  }
                </InputLabel>
                <Select
                  labelId="select-type-label"
                  id="select-type"
                  name="type"
                  value={form.type}
                  disabled={form.id ? true : false}
                  label={form.type === "selectUrl" ? t('myDesign.zones.schedule.form.type') + "place" : t('myDesign.zones.schedule.form.type')}
                  onChange={handleChange}
                >
                  {Object.values(SCHEDULE_TYPE).map((type) => {
                    if (type === SCHEDULE_TYPE.CAMPAIGN && !props.isMultiple && props.isAdmin) {
                      return (
                        <MenuItem key={type} value={type}
                          selected={form.id !== null && !(type === SCHEDULE_TYPE.NEW_VIDEO)}>{t(`myDesign.zones.schedule.form.${type}`)}</MenuItem>
                      )
                    } else if ((type === SCHEDULE_TYPE.CAMPAIGN && props.isMultiple) || (type === SCHEDULE_TYPE.CAMPAIGN && !props.isAdmin)) {
                      return null;
                    } else {
                      return (
                        <MenuItem key={type} value={type}
                          selected={form.id !== null && !(type === SCHEDULE_TYPE.NEW_VIDEO)}>{t(`myDesign.zones.schedule.form.${type}`)}</MenuItem>
                      )
                    }
                  }
                  )};
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              {form.type === SCHEDULE_TYPE.URL ?
                <FormControl fullWidth>
                  <InputLabel>{t('myDesign.zones.schedule.form.destination')}</InputLabel>
                  <Input
                    id="target-url"
                    label={t('myDesign.zones.schedule.form.destination')}
                    name="targetUrl"
                    value={form.targetUrl}
                    onChange={handleChange}
                    startAdornment={
                      <Button onClick={handleHttp}
                        className={classes.buttonHttp}>{form.http}</Button>
                    }
                  />
                </FormControl>
                : form.type === SCHEDULE_TYPE.CAMPAIGN ?
                  <div>
                    {selectedCampaign ?
                      <React.Fragment>
                        <FormControl className={classes.minW75} fullWidth style={{ marginBottom: '1rem' }}>
                          <InputLabel id="select-campaign-label">{t('myDesign.zones.schedule.form.campaignName')}
                          </InputLabel>
                          <Select
                            labelId="select-campaign-label"
                            id="select-campaign"
                            name="campaign"
                            disabled={form.id ? true : false}
                            value={selectedCampaign.uniqueKey}
                            onChange={(e) => handleCampaignChange(e.target.value)}
                          >
                            {props.campaigns.map((campaign) =>
                              <MenuItem key={campaign.uniqueKey} value={campaign.uniqueKey}
                                selected={campaign.id === selectedCampaign.campaignId}>{campaign.name}</MenuItem>
                            )};
                          </Select>
                        </FormControl>
                        <FormControl className={classes.minW75} fullWidth style={{ marginBottom: '1rem' }}>
                          <InputLabel id="select-campaign-type-label">{t('myDesign.zones.schedule.form.campaignType')}
                          </InputLabel>
                          <Select
                            labelId="select-campaign-type-label"
                            id="select-campaign-type"
                            name="campaign-type"
                            value={selectedCampaign.type}
                            disabled={form.id ? true : false}
                            onChange={(e) => handleCampaignValueChange(e.target.value, 'type')}
                          >
                            {selectedCampaign.availableTypes.map((type) =>
                              <MenuItem key={type} value={type}
                                selected={type === selectedCampaign.type}>{type}</MenuItem>
                            )};
                          </Select>
                        </FormControl>
                        <FormControl className={classes.minW75} fullWidth style={{ marginBottom: '1rem' }}>
                          <InputLabel id="select-algorithm-label">{t('myDesign.zones.schedule.form.readingMode')}
                          </InputLabel>
                          <Select
                            labelId="select-algorithm-label"
                            id="select-algorithm"
                            name="algorithm"
                            value={selectedCampaign.algorithm}
                            disabled={form.id ? true : false}
                            onChange={(e) => handleCampaignValueChange(e.target.value, 'algorithm')}
                          >
                            {Object.values(ALGORITHM_TYPE).map((algo) =>
                              <MenuItem key={algo} value={algo}
                                selected={algo === selectedCampaign.algorithm}>{algo}</MenuItem>
                            )};
                          </Select>
                        </FormControl>
                      </React.Fragment>
                      : !selectedCampaign && props.campaigns.length === 0 ?
                        <Container>
                          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                            <Typography>{t('myDesign.zones.schedule.form.noResults')}</Typography>
                          </div>
                        </Container>
                        :
                        <Container>
                          <div className="loading-container">
                            <CircularProgress size={50} />
                            <Typography>{t('loaders.fetching')}</Typography>
                          </div>
                        </Container>
                    }
                  </div>
                  :
                  <div>
                    <FormControl fullWidth>
                      <InputLabel>{t('myDesign.zones.schedule.form.videoTitle')}</InputLabel>
                      <Input
                        type="text"
                        id="video-title"
                        label={t('myDesign.zones.schedule.form.videoTitleLabel')}
                        name="videoTitle"
                        value={form.videoTitle || ''}
                        onChange={handleChange}
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>{t('myDesign.zones.schedule.form.videoDescription')}</InputLabel>
                      <Input
                        type="text"
                        id="video-description"
                        label={t('myDesign.zones.schedule.form.videoDescriptionLabel')}
                        name="videoDescription"
                        value={form.videoDescription || ''}
                        onChange={handleChange}
                      />
                    </FormControl>
                    {form.file &&
                      <FormControl fullWidth>
                        <Input id="video-file-text" disabled={true} value={form.file.name}
                          endAdornment={
                            <IconButton onClick={() => setForm({ ...form, file: null })} size="large">
                              <DeleteForever />
                            </IconButton>
                          }
                        />
                      </FormControl>
                    }
                    {(!form.file) &&
                      <div className={classes.buttonFile}>
                        <Button onClick={() => document.getElementById('file').click()}
                          variant="outlined">{t('myDesign.zones.schedule.form.select')}</Button>
                        <input
                          style={{ display: 'none' }}
                          type="file"
                          id="file"
                          label={t('myDesign.zones.schedule.form.destination')}
                          name="file"
                          accept={form.type === SCHEDULE_TYPE.NEW_VIDEO ? "video/avi, video/wmv, video/mov, video/rm, video/ram, video/swf, video/flv, video/ogg, video/webm, video/mp4" : "image/*"}
                          onChange={handleFileChange}
                        />
                      </div>
                    }
                  </div>
              }
            </Grid>
          </Grid>
          {/* </MuiPickersUtilsProvider> */}
        </LocalizationProvider>
        {!props.isMultiple &&
          <div className={classes.actionBar}>
            <div className={classes.flex1}>
              <Button color={"primary"} onClick={cancel}
                className={clsx(classes.fullHW, classes.noRadius)}>{t('myDesign.zones.schedule.form.cancel')}</Button>
            </div>
            <div className={classes.flex1}>
              <Button variant="contained" color={"primary"} onClick={validate} disabled={canSubmit}
                className={clsx(classes.fullHW, classes.noRadius)}>{isNaN(form.id) ? t('myDesign.zones.schedule.form.validate') : t('myDesign.zones.schedule.form.confirm')}</Button>
            </div>
            {!isNaN(form.id) &&
              <div className={classes.delete}>
                <Button onClick={confirmDeletePlanification}
                  className={classes.fullHW}>
                  <DeleteForever />
                </Button>
              </div>
            }
            <Slide direction="up" in={confirmDelete} mountOnEnter unmountOnExit>
              <div className={classes.confirmDelete}>
                <div className={classes.flex1}>
                  {t('myDesign.zones.schedule.form.deleteMessage')}
                </div>
                <div className={classes.flex02}>
                  <Button onClick={deletePlanification}>{t('myDesign.zones.schedule.form.yesAnswer')}</Button>
                </div>
                <div className={classes.flex02}>
                  <Button onClick={() => setConfirmDelete(false)}>{t('myDesign.zones.schedule.form.noAnswer')}</Button>
                </div>
              </div>
            </Slide>
          </div>
        }
      </div>
    </Root>
  );
}
